import * as React from "react";
const SvgFiRrLinkAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-link-alt_svg__a)">
      <path
        fill="#062147"
        d="M7.835 16.17a6.5 6.5 0 0 1-.641-.748 1 1 0 0 1 1.617-1.178q.193.268.437.511A4.22 4.22 0 0 0 12.253 16a4.22 4.22 0 0 0 3.005-1.245l5.5-5.5a4.256 4.256 0 0 0 0-6.01 4.256 4.256 0 0 0-6.011 0l-1.058 1.057a.999.999 0 1 1-1.414-1.414l1.058-1.058a6.255 6.255 0 0 1 8.839 0 6.257 6.257 0 0 1 0 8.84l-5.5 5.5a6.2 6.2 0 0 1-4.42 1.83 6.2 6.2 0 0 1-4.417-1.83M6.253 24c1.67 0 3.239-.65 4.419-1.83l1.058-1.059a.999.999 0 1 0-1.414-1.413l-1.06 1.058A4.22 4.22 0 0 1 6.253 22a4.22 4.22 0 0 1-3.005-1.244 4.22 4.22 0 0 1-1.245-3.006 4.22 4.22 0 0 1 1.245-3.004l5.5-5.5A4.22 4.22 0 0 1 11.752 8a4.22 4.22 0 0 1 3.005 1.245q.24.242.436.51A1 1 0 1 0 16.81 8.58a6 6 0 0 0-.64-.747A6.2 6.2 0 0 0 11.752 6c-1.668 0-3.238.65-4.418 1.831l-5.5 5.5a6.2 6.2 0 0 0-1.83 4.42c0 1.668.65 3.238 1.83 4.418A6.2 6.2 0 0 0 6.254 24"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-link-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLinkAlt;
